import { css, Global } from '@emotion/react';
import {
  m,
  mansionLayout,
  mansionMq,
  mansionRootVars,
} from '@/components/Mansion/tokens';
import { MansionPhase } from '@/components/Mansion/types';

/**
 * 34 MANSION 전용 전역 스타일.
 * 이 컴포넌트가 마운트된 동안에만 토큰(:root 변수)과 페이지 리셋이 적용됩니다.
 * 앱 공통 GlobalStyles 뒤에 삽입되므로 html/body 지정을 덮어씁니다.
 */
const mansionGlobalStyles = (dark: boolean) => css`
  :root {
    ${mansionRootVars}
  }

  ${mansionMq.mobile} {
    :root {
      /* 820px 이하 좌우 여백 */
      --m-gutter: ${mansionLayout.gutterMobile};
    }
  }

  html,
  body {
    margin: 0;
    padding: 0;
    /*
     * 히어로~리빌 구간에서는 문서 최상단 배경 자체를 남색으로 잡습니다.
     * 영상이 그려지기 전 한 프레임 동안 흰 화면이 지나가는 것을 막기 위한 것으로,
     * README 01 HERO 의 주의사항 그대로입니다.
     */
    background: ${dark ? m.surface.heroBg : m.surface.bg};
    color-scheme: ${dark ? 'dark' : 'light'};
    color: ${m.ink.text};
    font-family: ${m.type.sans};
    /* 앱 공통 GlobalStyles 의 line-height:1.5 를 되돌려 목업 기준(normal)에 맞춥니다. */
    line-height: normal;
    -webkit-font-smoothing: antialiased;
  }

  button {
    font-family: inherit;
    color: inherit;
  }

  /* 시스템 전면 border-radius 0. 브라우저 기본값도 되돌립니다. */
  button,
  input,
  select,
  textarea {
    border-radius: 0;
  }

  /* 11px 세리프 #9C9689 은 대비가 모자라 라벨은 이 조합으로 씁니다(tokens.css .m-label). */
  .m-label {
    font-size: ${m.type.label};
    font-weight: 500;
    letter-spacing: 0.24em;
    color: ${m.ink.textMuted};
  }

  /* 한글 문단은 어절 단위로 끊어야 읽힙니다. */
  .m-ko {
    word-break: keep-all;
    text-wrap: pretty;
  }

  @media (prefers-reduced-motion: reduce) {
    * {
      animation: none !important;
      transition: none !important;
    }
    /* 영상을 감추고 poster 이미지가 대신 보이게 합니다. */
    video {
      display: none !important;
    }
  }
`;

interface Props {
  phase: MansionPhase;
}

/** site 단계 전까지는 문서 배경을 남색으로 유지합니다. */
const MansionGlobalStyles = ({ phase }: Props) => (
  <Global styles={mansionGlobalStyles(phase !== 'site')} />
);

export default MansionGlobalStyles;
